import { REQUEST_METHOD } from '../../middlewares/services';

import * as types from './types';
import { endpoint } from '../../../config/const';

const list = (data) => ({
    type: types.COMMISSION_LIST,
    meta: {
        endpoint: endpoint.COMMISSION_LIST,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});

const detail = (data) => ({
    type: types.COMMISSION_DETAIL,
    meta: {
        endpoint: endpoint.COMMISSION_DETAIL,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});

const myCommission = (data) => ({
    type: types.MY_COMMISSION,
    meta: {
        endpoint: endpoint.MY_COMMISSION,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});
 
const commissionDetail = (data) => ({
    type: types.COMMISSION_DETAIL,
    meta: {
        endpoint: endpoint.COMMISSION_DETAIL,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});

export default {
    list,
    myCommission,
    detail,
    commissionDetail
}